angular.module('SpidApp')

.controller('CurrencyController',
        ['$scope', 'Restangular', '$localStorage', '$rootScope', 'CurrencyService', 'CurrencyHistoryService', 'Toaster',
function ($scope,   Restangular,   $localStorage,   $rootScope,   CurrencyService,   CurrencyHistoryService,   Toaster) {
        
    $scope.appControllerOver.then(function () {
	    
	    $scope.currency = $scope.agency.currency; 
	        
	    $scope.saveRate = function() {
	    	if (!$scope.agency.currency && !$scope.agency.currency.rate) {
	    		// error
	    		return;
	    	}
	    	
			var oldRate = $scope.currency.rate;
			$scope.currency.rate = +$scope.newRate;
	    	return CurrencyService.update($scope.currency, $scope.agency.id).then(function() {
	    		Toaster.show('Le taux de change a été mis à jour');
	    		$scope.newRate = null;
	    		getAllCurrenciesHistory();
	    	}).catch(function (error) {
				$scope.currency.rate = oldRate;
				console.error('CurrencyService::save() - ', error)
				Toaster.show('Impossible de sauvegarder le nouveau taux');
			})
	    }
	    
	    var getAllCurrenciesHistory = function() {
	    	if (!$scope.agency || !$scope.agency.currency) {
	    		return;
	    	}
	    	CurrencyHistoryService.find($scope.agency.id, $scope.agency.currency.id).then(function(currenciesHistory) {
	    		$scope.currenciesHistory = currenciesHistory;
	    	})
	    }
	    getAllCurrenciesHistory();
	})
}])